export const API_ORIGIN = process.env.API_ORIGIN
export const API_PATH = process.env.API_PATH
